import { render } from "./chart-statistic.vue?vue&type=template&id=0769a585&scoped=true"
import script from "./chart-statistic.vue?vue&type=script&lang=ts"
export * from "./chart-statistic.vue?vue&type=script&lang=ts"

import "./chart-statistic.vue?vue&type=style&index=0&id=0769a585&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-0769a585"

export default script